'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useRef, useState, useCallback } from 'react';
interface MasonryGridProps {
  children: ReactNode[];
  columnWidth?: number;
  gap?: number;
}
export function MasonryGrid(t0) {
  const $ = _c(24);
  const {
    children,
    columnWidth: t1,
    gap: t2
  } = t0;
  const columnWidth = t1 === undefined ? 280 : t1;
  const gap = t2 === undefined ? 16 : t2;
  const containerRef = useRef(null);
  const [columns, setColumns] = useState(1);
  const [mounted, setMounted] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  let t3;
  if ($[0] !== columnWidth || $[1] !== gap) {
    t3 = () => {
      if (!containerRef.current) {
        return;
      }
      const containerWidth = containerRef.current.offsetWidth;
      if (containerWidth === 0) {
        setTimeout(() => setForceUpdate(_temp), 50);
        return;
      }
      const cols = Math.max(1, Math.floor((containerWidth + gap) / (columnWidth + gap)));
      setColumns(cols);
    };
    $[0] = columnWidth;
    $[1] = gap;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const calculateColumns = t3;
  let t4;
  let t5;
  if ($[3] !== calculateColumns) {
    t4 = () => {
      setMounted(true);
      const rafId = requestAnimationFrame(() => {
        calculateColumns();
      });
      const resizeObserver = new ResizeObserver(() => {
        calculateColumns();
      });
      if (containerRef.current) {
        resizeObserver.observe(containerRef.current);
      }
      const handlePageShow = event => {
        if (event.persisted) {
          requestAnimationFrame(() => {
            calculateColumns();
          });
        }
      };
      const handleVisibilityChange = () => {
        if (!document.hidden) {
          requestAnimationFrame(() => {
            calculateColumns();
          });
        }
      };
      window.addEventListener("pageshow", handlePageShow);
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        cancelAnimationFrame(rafId);
        resizeObserver.disconnect();
        window.removeEventListener("pageshow", handlePageShow);
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t5 = [calculateColumns];
    $[3] = calculateColumns;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== calculateColumns || $[7] !== mounted) {
    t6 = () => {
      if (mounted) {
        requestAnimationFrame(() => {
          calculateColumns();
        });
        const timeoutId = setTimeout(() => {
          calculateColumns();
        }, 100);
        return () => clearTimeout(timeoutId);
      }
    };
    $[6] = calculateColumns;
    $[7] = mounted;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== calculateColumns || $[10] !== children.length || $[11] !== forceUpdate || $[12] !== mounted) {
    t7 = [children.length, mounted, calculateColumns, forceUpdate];
    $[9] = calculateColumns;
    $[10] = children.length;
    $[11] = forceUpdate;
    $[12] = mounted;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== children || $[15] !== columns) {
    const distributeChildren = () => {
      const columnHeights = new Array(columns).fill(0);
      const columnItems = Array.from({
        length: columns
      }, _temp2);
      children.forEach((child, index) => {
        const shortestColumn = columnHeights.indexOf(Math.min(...columnHeights));
        columnItems[shortestColumn].push(child);
        columnHeights[shortestColumn] = columnHeights[shortestColumn] + 1;
      });
      return columnItems;
    };
    t8 = distributeChildren();
    $[14] = children;
    $[15] = columns;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const columnItems_0 = t8;
  let t9;
  if ($[17] !== columnItems_0 || $[18] !== columns || $[19] !== gap || $[20] !== mounted) {
    t9 = mounted && <div className="grid" style={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: `${gap}px`
    }}>{columnItems_0.map((items, colIndex) => <div key={colIndex} className="flex flex-col" style={{
        gap: `${gap}px`
      }}>{items}</div>)}</div>;
    $[17] = columnItems_0;
    $[18] = columns;
    $[19] = gap;
    $[20] = mounted;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <div ref={containerRef} className="w-full">{t9}</div>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp2() {
  return [];
}
function _temp(prev) {
  return prev + 1;
}